import React, { FC } from 'react';
import styled from 'styled-components';

import { Senobi } from '~/styles/Senobi';
import { media } from '~/utils';

export const DiagnosisHeader: FC = () => {
  return (
    <Wrapper>
      <SubTitle>事業と活動地域を入力するだけ！</SubTitle>
      <Title>
        <Senobi>
          御社が最も貢献できる
          <br />
          重要社会課題を診断
        </Senobi>
      </Title>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-bottom: 10px;
  background: #61bfd4;
  height: 240px;
  width: 100%;
  border-radius: 0 0 40px 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${media.mid`
    height: 190px;
  `}
`;

const SubTitle = styled.h3`
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-weight: normal;

  ${media.mid`
    font-size: 16px;
  `}
`;

const Title = styled.h2`
  color: #fff;
  text-align: center;
  font-size: 50px;
  line-height: 55px;

  ${media.mid`
    font-size: 35px;
    line-height: 40px;
  `}
`;
